// CPF/CNPJ are identifiers: never cast to Number or truncate an extra digit.
function digits(value) {
  return String(value == null ? "" : value).replace(/\D/g, "")
}

function validLength(value) {
  return [11, 14].includes(digits(value).length)
}

function lengthMessage(value) {
  const count = digits(value).length
  if (!count) return "Informe um CPF com 11 dígitos ou um CNPJ com 14 dígitos."
  return `${count} ${count === 1 ? "dígito informado" : "dígitos informados"}. CPF deve ter 11 dígitos; CNPJ, 14.`
}

function formatted(value) {
  const document = digits(value)
  if (document.length === 11) return document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4")
  if (document.length === 14) return document.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5")
  return value
}

// Preserve the existing check-digit advisory. The shared registration/RENAVE
// requirement remains length; this advisory does not change the save policy.
function validCheckDigits(value) {
  const document = digits(value)
  if (!validLength(document) || /^(\d)\1+$/.test(document)) return false
  const numbers = document.split("").map(Number)
  const check = (base, weights) => {
    const sum = base.reduce((total, number, index) => total + number * weights[index], 0)
    const remainder = sum % 11
    return remainder < 2 ? 0 : 11 - remainder
  }
  if (numbers.length === 11) {
    return check(numbers.slice(0, 9), [10, 9, 8, 7, 6, 5, 4, 3, 2]) === numbers[9] &&
      check(numbers.slice(0, 10), [11, 10, 9, 8, 7, 6, 5, 4, 3, 2]) === numbers[10]
  }
  return check(numbers.slice(0, 12), [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]) === numbers[12] &&
    check(numbers.slice(0, 13), [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]) === numbers[13]
}

function validateField(field, showRequired = false) {
  const valid = validLength(field.value)
  const count = digits(field.value).length
  const invalid = !valid && (count > 0 || showRequired)
  const checked = valid && validCheckDigits(field.value)
  const feedback = field.parentElement.querySelector("[data-cliente-document-feedback]")
  const advisory = field.parentElement.querySelector("[data-cliente-document-advisory]")
  field.setCustomValidity(valid ? "" : lengthMessage(field.value))
  field.classList.toggle("is-invalid", invalid)
  field.classList.toggle("is-valid", checked)
  field.setAttribute("aria-invalid", String(invalid))
  if (feedback) {
    feedback.textContent = valid ? `${count} dígitos · ${count === 11 ? "CPF" : "CNPJ"}` : lengthMessage(field.value)
    feedback.classList.toggle("text-danger", invalid)
  }
  if (advisory) advisory.textContent = valid && !checked ? "Confira os dígitos verificadores do documento." : ""
  return valid
}

const boundFields = new WeakSet()
const boundForms = new WeakSet()
function initialize(root) {
  root.querySelectorAll("[data-cliente-document]").forEach((field) => {
    if (!boundFields.has(field)) {
      boundFields.add(field)
      field.addEventListener("input", () => validateField(field))
      field.addEventListener("blur", () => {
        field.value = formatted(field.value)
        validateField(field)
      })
      const form = field.form
      if (form && !boundForms.has(form)) {
        boundForms.add(form)
        const guard = (event) => {
          if (event.type === "click" && !event.target.closest("button[type='submit'], input[type='submit']")) return
          const invalid = Array.from(form.querySelectorAll("[data-cliente-document]")).find((input) => !validateField(input, true))
          if (!invalid) return
          event.preventDefault()
          event.stopImmediatePropagation()
          invalid.focus()
          invalid.reportValidity()
        }
        // Capture before legacy spinner handlers and Rails UJS, including Enter.
        form.addEventListener("click", guard, true)
        form.addEventListener("submit", guard, true)
      }
    }
    validateField(field)
  })
}

module.exports = { digits, validLength, lengthMessage, formatted, validCheckDigits, validateField, initialize }
